<template>
  <td
    v-for="(cell, index) in filteredCells"
    :key="cell.key"
    :class="classes"
    class="
      group-hover/row:tw-bg-sf-snow-light
      tw-transition-all
      hover:tw-cursor-pointer
    "
    :data-testid="
      index === 0 ? 'toggle-visibility' : `collapsible-group-cell-${index}`
    "
    @click="index === 0 ? toggleVisibility() : null"
  >
    <div
      :data-testid="`sf-column-${index}`"
      class="tw-flex tw-items-center tw-gap-2"
    >
      <div v-if="index === 0">
        <i
          class="
            fa fa-solid fa-angle-right
            tw-text-sf-gray-light tw-text-[16px] tw-transition-all
          "
          :class="caretClass"
        />
      </div>
      <slot name="cell-display" :cell="cell" :index="index">
        {{ cell.value }}
      </slot>
    </div>
  </td>
</template>

<script setup lang="ts" generic="TR extends GroupingTableRow">
import type { GroupingTableRow } from './types'

import { computed } from 'vue'

import { useFilteredCells } from './use-filtered-cells'
import { useCellStyles } from './use-cell-styles'
import type { TableVariants } from './constants'
import { tableVariants } from './constants'

interface Props {
  isExpanded: boolean
  ignoredColumns?: string[]
  rowData: TR
  variant?: TableVariants
}

const {
  isExpanded,
  rowData,
  ignoredColumns = ['id', 'group'],
  variant = tableVariants.DEFAULT,
} = defineProps<Props>()

const emits =
  defineEmits<{
    'toggle-visibility': [
      {
        group: string
        isExpanded: boolean
      }
    ]
  }>()

const { filteredCells } = useFilteredCells<TR>(rowData, ignoredColumns)
const { classes } = useCellStyles(variant)

const caretClass = computed(() => (isExpanded ? 'tw-rotate-90' : ''))

function toggleVisibility(): void {
  emits('toggle-visibility', {
    group: rowData.group,
    isExpanded: !isExpanded,
  })
}
</script>
